import React from "react";
import { CircleWithBadge } from "../../advancing/components";
import AdvancingRecipients from "../../components/AdvancingRecipients";
import { routes } from "utilities/routing/generatedRoutes";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";

interface Props {
  item: server.dto.AdvancingForList
}

const AdvancingRowCard = (props: Props) => {
  const { item } = props;

  const pendingCount = item.itemsApprovalPendingCount;
  const filesCount = item.filesCount;
  const messageCount = item.unreadMessageCount;

  return <div
    className="radius hoverable advancing-list-row"
    onClick={() => window.location.href = routes.advancingApprove_Detail(item.advancingId).absolute}
  >
    <div className="grow1 flex-column gap-small">
      <LinkedShowLines
        dateTime={item.show.dateTime}
        eventDescription={item.show.eventDescription}
        venueDescription={item.show.venueDescription}
        format="big" />

      <div className="s1_gray flex gap-small">
        <div>{item.createdUser.fullName}</div>
        <div><i className="icon-arrow-right s1_transparent60 small"></i></div>
        <AdvancingRecipients participants={item.participants} />
      </div>
    </div>

    <div className="flex gap advancing-badges">
      <CircleWithBadge icon="layers" count={pendingCount} badge="alert" title={(pendingCount === 1) ? `1 ${RESX.Advancing.itemPendingApproval}` : pendingCount + " " + RESX.Advancing.itemsPendingApproval} />
      <CircleWithBadge icon="paperclip" count={filesCount} title={(filesCount === 1) ? `1 ${RESX.File.resxFile}` : filesCount + " " + RESX.File.Files} />
      <CircleWithBadge icon="message" count={messageCount} badge="alert" title={(messageCount === 1) ? `1 ${RESX.Message.newMessage}` : messageCount + " " + RESX.Message.newMessages} />
    </div>
  </div>;
};

export default AdvancingRowCard;
